import {IUser} from "@/shared/domain/user.model";
import {AxiosResponse} from "axios";
import http from "../http-common";
import store from '@/store/index';
import {ANGULAR_WEB_URL} from "@/constants";

type Login = {
  cpfCnpj?: string;
  email?: string;
  password: string;
}

type JwtToken = {
  id_token: string;
};

class AccountService {
  get user(): IUser | null {
    return store.getters.getUser;
  }

  set user(user: IUser | null) {
    store.commit('changeUser', user);
  }

  public checkCpf(cpf: string): Promise<void | AxiosResponse<boolean | string>> {
    return http.get<boolean | string>(`account/check-cpf/${cpf}`);
  }

  public async login(cpfCnpj: string, password: string): Promise<void | AxiosResponse<IUser>> {
    const response = await this.authenticate(cpfCnpj, password);
    if (response && response.data) {
      return this.fetch();
    } else {
      throw "Error: Login failed";
    }
  }

  public async funeralSupplierLogin(email: string, password: string): Promise<void | AxiosResponse<IUser>> {
    const response = await this.funeralSupplierAuthenticate(email, password);
    if (response && response.data) {
      return this.fetch();
    } else {
      throw "Error: Login failed";
    }
  }

  authenticate(cpfCnpj: string, password: string): Promise<void | AxiosResponse<JwtToken>> {
    const data = {
      cpfCnpj,
      password
    } as Login;
    return http.post<JwtToken>(`authenticate`, data).then((res) => {
      if (res.data) {
        sessionStorage.setItem('authenticationToken', res.data.id_token);
      }
      return res;
    });
  }

  authenticateMag(login: string, password: string): Promise<void | AxiosResponse<JwtToken>> {
    const data = {
      username: login,
      password
    } as Login;
    return http.post<JwtToken>(`authenticate/mag`, data).then((res) => {
      if (res.data && res.status === 200) {
        store.commit('changeAuthenticationToken', res.data.id_token);
      }
      return res
    });
  }

  funeralSupplierAuthenticate(username: string, password: string): Promise<void | AxiosResponse<JwtToken>> {
    const data = {
      username,
      password
    } as Login;
    return http.post<JwtToken>(`authenticate`, data).then((res) => {
      if (res.data) {
        window.location.href = ANGULAR_WEB_URL + "account/tokenLogin?token=" + res.data.id_token;
      }
      return res;
    });
  }

  public resetPassword(email: string): Promise<void | AxiosResponse<any>> {
    return http.post(`account/reset-password/init`, email, {
      headers: {
        "Content-type": "text/plain"
      }
    });
  }

  public changePassword(currentPassword: string, newPassword: string): Promise<void | AxiosResponse<any>> {
    return http.post(`account/change-password`, {currentPassword, newPassword});
  }

  logout(): void {
    sessionStorage.removeItem('authenticationToken');
    this.user = null;
    store.commit('changeBeneficiaryDeath', null);
    store.commit('changeInsuranceContract', null);
  }

  isAuthenticated() {
    return this.user != null || sessionStorage.getItem('authenticationToken') != null || store.getters.getAuthenticationToken;
  }

  public async indentity(force?: boolean): Promise<void | any> {
    if (force || !this.isAuthenticated()) {
      return this.fetch().then((res) => {
        if (res && res.data) {
          this.user = res.data;
        }
      }).catch((res) => {
        console.log(res);
      })
    }
    return this.user;
  }

  public async save(user: IUser): Promise<void> {
    return http.post('account', user);
  }

  public async magLogin(login: string, password: string): Promise<void | AxiosResponse<IUser>> {
    const response = await this.authenticateMag(login, password);
    if (response && response.data) {
      return this.fetch();
    } else {
      throw "Error: Login failed";
    }

  }

  private fetch(): Promise<void | AxiosResponse<IUser>> {
    return http.get<IUser>('account');
  }

}

export default new AccountService();
